import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_Dashboard() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders, handlePresignedUrlDownload } =
    API_Calls_Utils();

  async function getDashboard(affiliate) {
    const queryParams = { affiliate, debug: "false" };
    // to protect that the debug dashboard data doesn't get to dev or staging or production
    if (
      window.location.href.includes("frontend.test") ||
      window.location.href.includes("frontend.staging") ||
      window.location.href.includes("ada.seiu")
    ) {
      queryParams.debug = false;
    }

    const { headers, queryString } = await queryParamsAndHeaders(queryParams);
    return await apiCall({
      url: `${backendUrl}/api/dashboard?${queryString}`,
      headers,
    });
  }

  async function downloadCatalistFile(affiliate, timestamp, customFields = {}) {
    const { format = "csv" } = customFields;
    const method = "POST";
    const params = {
      affiliate,
      timestamp,
      format,
    };
    const { headers, queryString } = await queryParamsAndHeaders(params);
    const url = `${backendUrl}/api/catalist/download?${queryString}`;
    const data = customFields.fields || [];
    return handlePresignedUrlDownload(url, headers, method, data);
  }

  async function deleteProcessedFile(affiliate, filename) {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      ada_file: filename,
    });
    return await apiCall({
      url: `${backendUrl}/api/processed?${queryString}`,
      method: "DELETE",
      headers,
    });
  }

  const setCatalistFieldPreferences = async (affiliate, bodyContent = null) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      setting: "preferred_catalist_fields",
    });
    return apiCall({
      url: `${backendUrl}/api/preferences?${queryString}`,
      method: "PUT",
      headers,
      data: bodyContent,
    });
  };

  const getDefaultCatalistFields = async () => {
    const { headers } = await queryParamsAndHeaders({});
    return apiCall({
      url: `${backendUrl}/api/catalist/fields`,
      method: "GET",
      headers,
    });
  };

  return {
    getDashboard,
    downloadCatalistFile,
    deleteProcessedFile,
    setCatalistFieldPreferences,
    getDefaultCatalistFields,
  };
}
